var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row pt-1", class: { "ml-0": _vm.isChild } }, [
      _c("div", { staticClass: "col-sm" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col" }, [
            _c("span", { staticClass: "data-name font-weight-normal" }, [
              _vm._v("Año Fiscal:")
            ]),
            _c("p", { staticClass: "data font-weight-normal" }, [
              _vm._v(" " + _vm._s(_vm.model.fiscalYearDescription) + " ")
            ])
          ])
        ]),
        (_vm.model.amendments || []).length > 0 && !_vm.isChild
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col" }, [
                _c(
                  "span",
                  { staticClass: "color-primary-2 font-weight-normal" },
                  [
                    _vm._v(
                      " (" +
                        _vm._s(_vm.model.amendments.length) +
                        ") Enmienda(s) "
                    )
                  ]
                )
              ])
            ])
          : _vm._e()
      ]),
      _c("div", { staticClass: "col-sm" }, [
        _c("span", { staticClass: "data-name font-weight-normal" }, [
          _vm._v("Número de Contrato:")
        ]),
        _c("p", { staticClass: "data font-weight-normal" }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.model.contractNumber ? _vm.model.contractNumber : "-"
              ) +
              " "
          )
        ])
      ]),
      _c("div", { staticClass: "col-sm" }, [
        _c("span", { staticClass: "data-name font-weight-normal" }, [
          _vm._v(" Fecha Comienzo/Finalización: ")
        ]),
        _c("p", { staticClass: "data font-weight-normal" }, [
          _vm._v(" " + _vm._s(_vm.getStartEndDate(_vm.model)) + " ")
        ])
      ]),
      _vm.model.isDirectPayment
        ? _c("div", { staticClass: "col-sm-2 mt-2" }, [
            _c(
              "span",
              {
                staticClass: "badge badge-pill badge p-2 px-2",
                class: `border-color--green`,
                staticStyle: { "background-color": "#e3ffe9" }
              },
              [
                _c("em", { class: `fas fa-dollar-sign color-green` }),
                _c(
                  "span",
                  {
                    staticClass: "font-weight-bold ml-1",
                    class: `color-green`
                  },
                  [_vm._v(" Pago Directo ")]
                )
              ]
            )
          ])
        : _c("div", { staticClass: "col-sm-2" }, [
            _c("span", { staticClass: "data-name font-weight-normal" }, [
              _vm._v("Monto:")
            ]),
            _c("p", { staticClass: "data font-weight-normal" }, [
              _vm._v(
                " " + _vm._s(_vm._f("price")(_vm.model.balanceMaxAmt)) + " "
              )
            ])
          ]),
      _c("div", { staticClass: "col-sm-1" }, [
        !_vm.isChild
          ? _c("span", { staticClass: "data-name font-weight-normal" }, [
              _vm._v("Total:")
            ])
          : _vm._e(),
        !_vm.isChild
          ? _c("p", { staticClass: "data font-weight-normal" }, [
              _vm._v(
                " " + _vm._s(_vm._f("price")(_vm.model.totalBalance)) + " "
              )
            ])
          : _vm._e()
      ]),
      _c(
        "div",
        { staticClass: "col-sm text-center" },
        [
          _c("drop-down", {
            class: { "ml-3": _vm.isChild },
            attrs: {
              "data-item": _vm.model,
              items: _vm.getAvailableActions(_vm.model)
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }